export const THEME_COLOR_LIGHT = "#ffffff"
export const THEME_COLOR_DARK = "#121212"

/** Remove every theme-color meta (manifest, Helmet, Head) and set a single fresh tag. */
export function setThemeColor(color) {
  if (typeof document === "undefined") return

  document.querySelectorAll('meta[name="theme-color"]').forEach((el) => el.remove())

  const meta = document.createElement("meta")
  meta.name = "theme-color"
  meta.content = color
  document.head.appendChild(meta)
}

/** Fallback when layouts have not mounted yet after client-side navigation. */
export function getThemeColorForPath(pathname) {
  const path = pathname.endsWith("/") ? pathname : `${pathname}/`

  if (path === "/reiseziele/") {
    return THEME_COLOR_LIGHT
  }

  if (
    path.startsWith("/reiseziele/") ||
    path.startsWith("/blog") ||
    path.startsWith("/weltreise") ||
    path.startsWith("/ueber-uns") ||
    path.startsWith("/admin") ||
    path === "/404/"
  ) {
    return THEME_COLOR_DARK
  }

  if (path === "/") {
    return THEME_COLOR_DARK
  }

  const segments = path.split("/").filter(Boolean)
  if (segments.length === 1) {
    return THEME_COLOR_LIGHT
  }
  if (segments.length === 2 && segments[1] === "album") {
    return THEME_COLOR_LIGHT
  }

  return THEME_COLOR_DARK
}

export function syncThemeColorForPath(pathname) {
  setThemeColor(getThemeColorForPath(pathname))
}
